import styled from 'styled-components';
import { colors, remCalc } from '@prisjakt/ui-base';

export const QuickPriceFilter = styled.div`
  margin-top: ${remCalc(5)};
  margin-bottom: ${remCalc(5)};
  padding-right: ${remCalc(10)};
  align-self: center;
  border-right: 1px solid ${colors.lightGray2};
`;
